var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfigurations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Settings",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(4.000000, 4.000000)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2289474,19.1052632 L20.9305263,20.6715789 L23.94,15.5873684 L20.9210526,13.8363158 C21.1600501,12.6886324 21.1713159,11.5051831 20.9542105,10.3531579 L24,8.62578947 L21.0394737,3.51315789 L18.0173684,5.22631579 C17.1244143,4.44593074 16.0883894,3.84640904 14.9668421,3.46105263 L14.9668421,0 L9.01263158,0 L9.01263158,3.45 C7.90230361,3.82648177 6.87470771,4.41291365 5.98578947,5.17736842 L3.01578947,3.45473684 L0,8.53894737 L3,10.2757895 C2.77475066,11.4184791 2.77475066,12.5941525 3,13.7368421 L0,15.4421053 L2.96052632,20.5547368 L6,18.84 C6.88724478,19.6007338 7.91203706,20.1844152 9.01894737,20.5594737 L9.01894737,24 L14.9731579,24 L14.9731579,20.5484211 C16.1727763,20.3839421 17.3014483,19.8836481 18.2289474,19.1052632 Z",
    id: "622ed3f9-81c0-4219-8b01-bcbd8f596c75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4115789,11.7126316 C16.5312691,13.5493757 15.5004381,15.2681095 13.8237226,16.027438 C12.1470071,16.7867664 10.1752558,16.4278018 8.87372698,15.126273 C7.57219816,13.8247442 7.21323357,11.8529929 7.97256202,10.1762774 C8.73189047,8.49956192 10.4506243,7.46873088 12.2873684,7.58842105 C14.5025624,7.73277266 16.2672273,9.4974376 16.4115789,11.7126316 L16.4115789,11.7126316 Z",
    id: "ec65c131-82ae-44a4-a87e-b620c5c291c4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurations);
export default __webpack_public_path__ + "static/media/configurations.c727168b91408bb7fee4e9cba254eafa.svg";
export { ForwardRef as ReactComponent };